import one from '../assets/png/ss.png'
import two from '../assets/png/ss1.png'
import three from '../assets/png/ss6.png'
import four from '../assets/png/ss3.png'
import five from '../assets/png/ss4.png'
import nine from '../assets/png/ss2.png'
import six from '../assets/png/ss5.png'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'E-Journal',
        projectDesc: 'Easy to use and a very handy website to write your journals in.',
        tags: ['ExpressJs', 'NodeJS', 'MongoDB'],
        code: 'https://github.com/Akshithachinthakindi/E-Journal',
        demo: 'https://journal-ly.onrender.com/journal',
        image: one
    },
    {
        id: 2,
        projectName: 'Hidden Gems',
        projectDesc: 'Hidden Gems is a platform for wanderers who loves to explore different places.',
        tags: ['HTML5', 'CSS3', 'ReactJS', 'Bootstrap'],
        code: 'https://github.com/Akshithachinthakindi/Hidden-Gems',
        demo: 'https://hidden-gems-nine.vercel.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Medicine Recommendation System',
        projectDesc: 'It is an AI & ML application where user can enter his/her disease symptoms and get the accurate personalised healthcare prediction.',
        tags: ['HTML5', 'CSS3', 'JavaScript', 'ML Algorithms', 'Data Visualization'],
        code: 'https://github.com/Akshithachinthakindi/Medicine-Recommendation-System',
        // demo: 'https://akshithachinthakindi.github.io/VConnect-master/',
        image: three
    },
    {
        id: 4,
        projectName: 'Chase',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/Akshithachinthakindi/Chase-website',
        demo: 'https://akshithachinthakindi.github.io/Chase-website/',
        image: four
    },
    {
        id: 5,
        projectName: 'VConnect',
        projectDesc: 'An innovative platform where women in STEM fields can come together and discuss.',
        tags: ['HTML5', 'CSS3', 'JavaScript'],
        code: 'https://github.com/Akshithachinthakindi/VConnect-master',
        demo: 'https://akshithachinthakindi.github.io/VConnect-master/',
        image: nine
    },
    {
        id: 6,
        projectName: 'E-Learning Portal',
        projectDesc: 'A simple web application which helps us study online.',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/Akshithachinthakindi/E-Learning-Portal',
        demo: '',
        image: six
    },
    // {
    //     id: 7,
    //     projectName: 'Example Project1',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: '',
    //     demo: '',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Example Project2',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: '',
    //     demo: '',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/